import * as angular from "angular";
import * as _ from "lodash";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { HouseHelperService } from "../house/house.helper";
import { Field } from "../../models/field.model";
import { House } from "../../models/house.model";
import { VoterFileService } from "../../services/voter-file.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let ConfirmImportComponent = {
    selector: "vcConfirmImport",
    templateUrl: "/angular/components/voter-file/confirm-import.component.html",
    bindings: {
        registerColumns: "=",
        register: "=",
        campaignColumn: "=",
        imname: "=",
        importDataType: "=",
    },
    controller: class ConfirmImportController {
        // * bindings for typescript compiler *
        public registerColumns: any;
        public register: any;
        public campaignColumn: any;
        public imname: string;
        public importDataType: string;
        // ************************************

        private readonly houseHelper: HouseHelperService;
        private readonly service: VoterFileService;
        private readonly dialog: DialogUtils;
        private dataProvider: VoterFileDataProvider;
        public readonly __env: any;
        private readonly modelsUtils: any;
        private readonly $window: any;
        private readonly toast: ToastUtils;

        public houseMarker: any = null;
        public map = {
            bounds: {},
            center: { latitude: 0, longitude: 0 },
            zoom: 3,
            control: {},
        };
        public isLeaderView: boolean;
        public row = 1;
        public pagination = 0;
        public importType = 0;
        public missingFields: string[] | null = null;
        public firstVoterFile = false;
        public hasVoterID: boolean;
        public fields: Field[] = [];
        public populatedFields: Field[];
        public house: House;
        public locationError: string | null;
        public originalHouseMarker: object;
        public dialogHeadings = [
            "Warning",
            "Verify Details",
            "Select Import Type",
        ];
        public registerColumnsCopy?: any;
        public loading?: boolean;
        public missingFieldsText?: any;
        public columnsData?: any[];

        constructor(
            HouseHelperService: HouseHelperService,
            VoterFileService: VoterFileService,
            DialogUtils: DialogUtils,
            VoterFileDataProvider: VoterFileDataProvider,
            __env: any,
            ModelsUtils: any,
            __app_type: string,
            $window: any,
            ToastUtils: ToastUtils
        ) {
            this.toast = ToastUtils;
            this.houseHelper = HouseHelperService;
            this.service = VoterFileService;
            this.dialog = DialogUtils;
            this.dataProvider = VoterFileDataProvider;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
            this.isLeaderView = __app_type === "LEADER";

            this.$window = $window;
        }

        $onInit() {
            this.dataProvider
                .getColumnsData(this.register.erid)
                .then((data: any[]) => {
                    this.columnsData = data;
                    this.registerColumnsCopy = _.cloneDeep(
                        this.registerColumns
                    );

                    for (let i = 0; i < this.registerColumnsCopy.length; i++) {
                        angular.forEach(this.columnsData, (column) => {
                            if (
                                column[0] ==
                                this.registerColumnsCopy[i]["data"][0]
                            ) {
                                this.registerColumnsCopy[i]["data"] = column;
                            }
                        });
                    }

                    this.dataProvider.getVoterFiles().then((files: File[]) => {
                        if (files.length === 1 && !this.isLeaderView)
                            this.firstVoterFile = true;
                    });

                    this.dataProvider.getFields().then((fields: Field[]) => {
                        this.fields = fields;
                        this.formatFields(this.fields);

                        this.hasVoterID = this.getValueForColumnID(16) !== "";
                        this.checkFields();
                        this.locate();
                    });
                });
        }

        getValueForColumnID(columnid: string | number): any {
            const obj = this.registerColumnsCopy.filter(
                (registerColumn: any) => {
                    if (registerColumn.columnid == columnid) {
                        return registerColumn;
                    }
                }
            );
            if (obj.length) {
                let column = obj[0];
                if (column.data.length > this.row) return column.data[this.row];
            }
            return "";
        }

        dialogHeading(): string {
            if (this.loading) return "";
            return this.dialogHeadings[this.pagination];
        }

        checkFields(): void {
            let importRegister = this.register;
            importRegister.columns = this.registerColumnsCopy;
            importRegister.importType = this.importType;
            this.loading = true;
            this.service.check(importRegister).then((response: object) => {
                const json = response["data"];
                this.loading = false;
                if (json.success) {
                    this.pagination = 1;
                } else {
                    this.missingFields = [];
                    json.data.forEach((fieldData: object) => {
                        this.missingFields.push(fieldData["columnname"]);
                    });
                    this.missingFieldsText = this.missingFields.join(", ");
                }
            });
        }

        formatFields(fields: Field[]): void {
            this.populatedFields = [];
            for (let i = 0; i < fields.length; i++) {
                let category: any = {
                    columncategory: fields[i].columncategory,
                    columns: [],
                };
                for (let j = 0; j < fields[i].columns.length; j++) {
                    let field = fields[i].columns[j];
                    let value = this.getValueForColumnID(field.columnid);
                    if (value !== "") {
                        field.rowvalue = value;
                        category.columns.push(field);
                    }
                }
                if (category.columns.length) {
                    this.populatedFields.push(category);
                }
            }
        }

        nextRow(): void {
            if (this.row < 4) {
                this.row++;
                this.formatFields(this.fields);
                this.locate();
            }
        }

        previousRow(): void {
            if (this.row > 1) {
                this.row--;
                this.formatFields(this.fields);
                this.locate();
            }
        }

        locate(): void {
            this.house = this.modelsUtils.house({
                hunit:
                    this.getValueForColumnID(36) +
                    " " +
                    this.getValueForColumnID(4),
                hnumber: this.getValueForColumnID(5),
                hname: this.getValueForColumnID(23),
                haddress:
                    this.getValueForColumnID(6) +
                    " " +
                    this.getValueForColumnID(33) +
                    " " +
                    this.getValueForColumnID(32),
                hcity: this.getValueForColumnID(7),
                hstate: this.getValueForColumnID(8),
                hzipcode: this.getValueForColumnID(9),
                hprecint:
                    this.getValueForColumnID(10) +
                    " " +
                    this.getValueForColumnID(36),
            });
            this.locationError = null;
            this.houseHelper.locate(
                this.house,
                (location: any) => {
                    this.setOriginalMarker();
                    this.houseMarker = {
                        id: 1,
                        locationtype: location.locationtype,
                        coords: location.coords,
                        options: {
                            title: "Suggested Location",
                        },
                    };
                    this.setMapCenter();
                },
                (error: any) => {
                    if (error.hlocationtype === "ZERO_RESULTS") {
                        this.locationError =
                            "Could not find coordinates for that address.";
                    } else {
                        this.locationError =
                            "Could not connect to Google Maps right now";
                    }
                    this.houseMarker = null;
                    this.setMapCenter();
                }
            );
        }

        setOriginalMarker(): void {
            // house had a original location and there isn't a marker for it.
            if (
                !this.originalHouseMarker &&
                this.house &&
                this.house.hlatitude &&
                (this.house.hlatitude + "").trim() != "" &&
                this.house.hlongitude &&
                (this.house.hlongitude + "").trim() != ""
            ) {
                this.originalHouseMarker = {
                    id: 2,
                    coords: {
                        latitude: this.house.hlatitude,
                        longitude: this.house.hlongitude,
                    },
                    options: {
                        title: "Original Location",
                        icon: "http://maps.google.com/mapfiles/ms/micons/blue.png",
                    },
                };
            }
        }

        setMapCenter(): void {
            if (this.houseMarker) {
                this.map.center = _.cloneDeep(this.houseMarker.coords);
                this.map.zoom = 15;
            } else {
                // no markers anywhere show the world
                this.map.center = { latitude: 0, longitude: 0 };
                this.map.zoom = 3;
            }
        }

        left(ev: object): void {
            if (
                this.pagination === 0 ||
                (this.pagination === 1 && !this.missingFields)
            ) {
                this.dialog.cancel();
            } else {
                this.pagination--;
            }
        }

        right(ev: object): void {
            if (
                this.pagination === 2 ||
                (this.pagination === 1 &&
                    (this.hasVoterID ||
                        this.firstVoterFile ||
                        this.importDataType == "houses"))
            ) {
                this.confirm(ev);
            } else {
                this.pagination++;
            }
        }

        confirm(ev: object): void {
            let importRegister = this.register;
            importRegister.columns = this.registerColumnsCopy;
            importRegister.importType = this.importType;
            importRegister.campaignColumn = this.campaignColumn;
            importRegister.imname = this.imname;
            if (this.importDataType) {
                importRegister.options = { datatype: this.importDataType };
            }
            if (importRegister.importType == 0 && this.hasVoterID) {
                importRegister.importType = 1;
            }

            this.loading = true;
            this.service.import(importRegister).then((response: object) => {
                const json = response["data"];
                if (json.imid) {
                    this.service
                        .insert({
                            id: json.imid,
                            campaignColumn: this.campaignColumn,
                        })
                        .then(
                            (response: object) => {
                                const json = response["data"];
                                this.loading = false;
                                if (json.success) {
                                    this.dialog.hide();
                                }
                            },
                            // Refused while import data is being deleted (AV-18260)
                            (error: any) => {
                                this.loading = false;
                                this.toast.error(error?.data ?? error);
                            }
                        );
                } else {
                    const dialog = this.dialog
                        .alert()
                        .title("Error")
                        .textContent(
                            "There was an issue reading this file. For .xlsx files, try converting to a .csv file then re-upload the converted file. Please contact support should you continue to experience issues with your file."
                        )
                        .targetEvent(ev)
                        .ok("OK");
                    this.dialog.showPreConfiguredDialog(dialog).then(() => {
                        if (this.isLeaderView) {
                            this.$window.location =
                                "./leader.php/#/leader_voterfiles";
                        } else {
                            this.$window.location.href = "./#/voterfiles";
                        }
                    });
                }
            }, (error: any) => {
                // Refused while import data is being deleted (AV-18260)
                this.loading = false;
                this.toast.error(error);
            });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("voterFile")
    .component(ConfirmImportComponent.selector, ConfirmImportComponent);
